import { OWN_ORIGIN } from "@/base/base.constants";

const CHALLENGES_ROUTES = {
  HOME: {
    route: `${OWN_ORIGIN}/home`,
    contents: "Home",
  },
  LANDING: {
    route: `${OWN_ORIGIN}/challenges`,
    contents: "Challenges",
  },
  DETAIL: (contentId) => {
    return {
      route: `${OWN_ORIGIN}/challenges/${contentId}`,
      contents: "Detail",
    };
  },
  HISTORY: {
    route: `${OWN_ORIGIN}/challenges/history`,
    contents: "History",
  },
  REWARDS: {
    route: `${OWN_ORIGIN}/challenges/rewards`,
    contents: "Rewards",
  },
};

export default CHALLENGES_ROUTES;
